<template>
	<pagina-erro
		titulo="Período encerrado"
		icone="fa fa-hourglass-end"
		imagemTexto="centralservidor-logo-texto.png"
		imagem="centralservidor-logo.png"
		texto="Periodo está fechado para lançamento." >
	</pagina-erro>
</template>

<script >
import PaginaErro from '@/components/pagina-erro'

export default {
	name: 'PeriodoEncerrado',
	components: {
		PaginaErro
	}
}
</script>




// WEBPACK FOOTER //
// index.vue?b0946eea